import type { PlaybookQuery } from "@qw/graphql";
import type { FC } from "react";

export interface PlaybookAuthorProps {
  author: PlaybookQuery["playbook"]["author"];
}

export const PlaybookAuthor: FC<PlaybookAuthorProps> = ({ author }) => (
  <div>
    <h3 className="text-xs font-semibold text-muted-foreground">Author</h3>
    <p className="text-sm">
      {author ? `${author.firstName || ""} ${author.lastName || ""}`.trim() || "Unknown" : "Unknown"}
    </p>
  </div>
);
